/**
 * Created by sagardesai on 13/07/18.
 */

import {
  API_ENDPOINT,
  API_ENDPOINT_V2,
  AUTH_HEADERS,
} from "../../util/constants";
import { RSAA } from "redux-api-middleware";
import * as types from "../types/index";
import { handleUnauthorizedAccess } from "../../util/utility";

export function requestAvailabilityBroadcast(token, api_token, data) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/request/session/broadcaster/availability?api_token=${api_token}`,
      method: "POST",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
      types: [
        types.REQUEST_AVAILABILITY_BROADCAST,
        types.REQUEST_AVAILABILITY_BROADCAST_RECEIVE,
        {
          type: types.REQUEST_AVAILABILITY_BROADCAST_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export const resetAvaibilityBroadcast = () => ({
  type: types.RESET_AVAILABILITY_BROADCAST,
  payload: null,
});

export function withdrawAvailabilityBroadcast(token, api_token, data) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/withdraw/request/session/broadcaster/availability?api_token=${api_token}`,
      method: "POST",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
      types: [
        types.WITHDRAW_AVAILABILITY_BROADCAST,
        types.WITHDRAW_AVAILABILITY_BROADCAST_RECEIVE,
        {
          type: types.WITHDRAW_AVAILABILITY_BROADCAST_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export const resetWithdrawAvaibilityBroadcast = () => ({
  type: types.RESET_WITHDRAW_AVAILABILITY_BROADCAST,
  payload: null,
});

export function getAllRequestForBroadcast(token, api_token, availabilityId) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/broadcaster/availability/broadcast/${availabilityId}?api_token=${api_token}`,
      method: "GET",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      types: [
        types.GET_ALL_REQUEST_AVAILABILITY_BROADCAST,
        types.GET_ALL_REQUEST_AVAILABILITY_BROADCAST_RECEIVE,
        {
          type: types.GET_ALL_REQUEST_AVAILABILITY_BROADCAST_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export const resetGetAllRequestForBroadcast = () => ({
  type: types.RESET_GET_ALL_REQUEST_AVAILABILITY_BROADCAST,
  payload: null,
});

export function favouriteUser(token, api_token, user_id, broadcast_id) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/favorite/user/${user_id}?api_token=${api_token}&broadcast_id=${broadcast_id}`,
      method: "GET",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      types: [
        types.FAVORITE_USER,
        types.FAVORITE_USER_RECEIVE,
        {
          type: types.FAVORITE_USER_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export function unFavouriteUser(token, api_token, user_id,broadcast_id) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/unfavorite/user/${user_id}?api_token=${api_token}&broadcast_id=${broadcast_id}`,
      method: "GET",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      types: [
        types.UNFAVORITE_USER,
        types.UNFAVORITE_USER_RECEIVE,
        {
          type: types.UNFAVORITE_USER_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export const resetFavouriteUser = () => ({
  type: types.RESET_FAVORITE_USER,
  payload: null,
});

export function blockUser(token, api_token, user_id,user_type = "user") {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/block/user/${user_id}?api_token=${api_token}&user_type=${user_type}`,
      method: "POST",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      types: [
        types.BLOCK_USER,
        types.BLOCK_USER_RECEIVE,
        {
          type: types.BLOCK_USER_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export function unBlockUser(token, api_token, user_id) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/unblock/user/${user_id}?api_token=${api_token}`,
      method: "GET",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      types: [
        types.UNBLOCK_USER,
        types.UNBLOCK_USER_RECEIVE,
        {
          type: types.UNBLOCK_USER_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export const resetBlockUser = () => ({
  type: types.RESET_BLOCK_USER,
  payload: null,
});

export function removeUserRequest(token, api_token, request_id, broadcast_id) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/decline/request/${request_id}?api_token=${api_token}&broadcast_id=${broadcast_id}`,
      method: "GET",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      types: [
        types.REMOVE_AVAILABILITY_REQUEST,
        types.REMOVE_AVAILABILITY_REQUEST_RECEIVE,
        {
          type: types.REMOVE_AVAILABILITY_REQUEST_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export const resetRemoveUserRequest = () => ({
  type: types.RESET_REMOVE_AVAILABILITY_REQUEST,
  payload: null,
});

export function broadcasterAcceptRequestOnBroadcastID(
    token,
    api_token,
    broadcastID,
    data
) {

    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/accept/request/session/broadcaster/broadcast/${broadcastID}?api_token=${api_token}`,
            method: "POST",
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
            types: [
                types.BROADCASTER_ACCEPT_REQUEST,
                types.BROADCASTER_ACCEPT_REQUEST_RECEIVE,
                {
                    type: types.BROADCASTER_ACCEPT_REQUEST_FAILURE,
                    meta: (action, state, res) => {
                        return handleUnauthorizedAccess(action, state, res);
                    },
                },
            ],
        },
    };
}

export const resetBroadcasterAcceptRequestOnBroadcastID = () => ({
    type: types.RESET_BROADCASTER_ACCEPT_REQUEST,
    payload: null,
});

export function broadcasterAcceptRequest(
  token,
  api_token,
  availabilityID,
  data
) {

  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/accept/request/session/broadcaster/availability/${availabilityID}?api_token=${api_token}`,
      method: "POST",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
      types: [
        types.BROADCASTER_ACCEPT_REQUEST,
        types.BROADCASTER_ACCEPT_REQUEST_RECEIVE,
        {
          type: types.BROADCASTER_ACCEPT_REQUEST_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export const resetbroadcasterAcceptRequest = () => ({
  type: types.RESET_BROADCASTER_ACCEPT_REQUEST,
  payload: null,
});

// Broadcaster Timeout Request
export function broadcasterTimeoutRequest(
  token,
  api_token,
  requestId,
  broadcast_id
) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/timeout/request/${requestId}?api_token=${api_token}&broadcast_id=${broadcast_id}`,
      method: "GET",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      types: [
        types.BROADCASTER_TIMEOUT_REQUEST,
        types.BROADCASTER_TIMEOUT_REQUEST_RECEIVE,
        {
          type: types.BROADCASTER_TIMEOUT_REQUEST_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}
export const resetbroadcasterTimeoutRequest = () => ({
  type: types.RESET_BROADCASTER_TIMEOUT_REQUEST,
  payload: null,
});

export const showAcceptOneToOneAvailabilityDialog = (data) => ({
  type: types.SHOW_ACCEPT_ONE_TO_ONE_AVAILABILITY_REQ_DIALOG,
  payload: data,
});

export const hideAcceptOneToOneAvailabilityDialog = () => ({
  type: types.HIDE_ACCEPT_ONE_TO_ONE_AVAILABILITY_REQ_DIALOG,
  payload: null,
});

export function getNotificationData(token, api_token, notificationId) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/user/notifications/${notificationId}?api_token=${api_token}`,
      method: "GET",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      types: [
        types.GET_NOTIFICATION_DATA,
        types.GET_NOTIFICATION_DATA_RECEIVE,
        {
          type: types.GET_NOTIFICATION_DATA_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export const resetNotificationData = () => ({
  type: types.RESET_NOTIFICATION_DATA,
  payload: null,
});

export const setNotificationDataFromNotificationPanel = (data) => ({
  type: types.SET_NOTIFICATION_DATA_FROM_NOTIFICATION_PANEL,
  payload: data,
});

export function acceptAvailabilityRequest(token, api_token, request_id) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/accept/session/${request_id}?api_token=${api_token}`,
      method: "GET",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      types: [
        types.ACCEPT_AVAILABILITY_REQUEST,
        types.ACCEPT_AVAILABILITY_REQUEST_RECEIVE,
        {
          type: types.ACCEPT_AVAILABILITY_REQUEST_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export function declineAvailabilityRequest(token, api_token, request_id) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/decline/session/${request_id}?api_token=${api_token}`,
      method: "GET",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      types: [
        types.DECLINE_AVAILABILITY_REQUEST,
        types.DECLINE_AVAILABILITY_REQUEST_RECEIVE,
        {
          type: types.DECLINE_AVAILABILITY_REQUEST_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export const resetAvailabilityRequest = () => ({
  type: types.RESET_ACCEPT_AVAILABILITY_REQUEST,
  payload: null,
});

export const resetDeclineAvailabilityRequest = () => ({
  type: types.RESET_DECLINE_AVAILABILITY_REQUEST,
  payload: null,
})

export const updateOneToOneAvailabilityList = (data) => ({
  type: types.ONE_TO_ONE_AVAILABILITY_REQUEST_LIST,
  payload: data,
})

export const updateGroupAvailabilityList = (data) => ({
  type: types.GROUP_AVAILABILITY_REQUEST_LIST,
  payload: data,
})

export const updatePrivateAvailabilityList = (data) => ({
  type: types.PRIVATE_AVAILABILITY_REQUEST_LIST,
  payload: data,
})

export const resetAvailabilityList = () => ({
  type: types.RESET_AVAILABILITY_REQUEST_LIST,
  payload: null
})

export const resetAvailabilityFlag = () => ({
  type: types.RESET_ACCEPT_AVAILABILITY_FLAG,
  payload: null
})

